/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';

import styles from './tab.module.scss';

const Tab = ({
  label,
  onClick,
  activeTab,
  tabId,
  toggleDropdown,
  content,
  type,
  sport,
  gtmClass,
}) => {
  let className = '';
  if (activeTab.label === tabId) {
    className = ` ${styles.active}`;
  }

  return (
    <li className={`${styles.tabListItem} ${styles[type]}`}>
      <button
        className={`${className} ${sport} ${gtmClass} tabs-menu-gtm`}
        type="button"
        onClick={() => {
          onClick({ label: tabId, content });
          // eslint-disable-next-line no-unused-expressions
          toggleDropdown && toggleDropdown();
        }}
      >
        {content || label}
      </button>
    </li>
  );
};
Tab.propTypes = {
  onClick: PropTypes.func,
  toggleDropdown: PropTypes.func,
  activeTab: PropTypes.shape({
    label: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
  }),
  tabId: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
  type: PropTypes.oneOf(['calendar', 'providers']),
  sport: PropTypes.oneOf(['soccer', 'handball', 'tennis']),
  gtmClass: PropTypes.string,
  label: PropTypes.string,
};

export default Tab;
